export default __webpack_public_path__ + "static/media/approach2.f043cbb6.png";